// extracted by mini-css-extract-plugin
export var container = "_c7-0";
export var popoverContent = "_c7-1";
export var tosLink = "_c7-2";